module.exports = __webpack_public_path__ + "static/media/rocket.d09635f2.jpg";